import request from "./../utils/request";
import _ from "lodash";
import axios from "axios";
import log2 from "../utils/log2";
const log = log2("TABLE_API");
export const TABLE_API = {
    listTables: (params) => {
        return request({
            url: `/tables`,
            method: "get",
            params: params,
        }).then((response) => response.data);
    },
    listDeletedTables: () => {
        return request({
            url: `/tables/list-deleted`,
            method: "get",
        }).then((response) => response.data);
    },
    restoreTable: (id) => {
        return request({
            url: `/tables/${id}/restore-deleted`,
            method: "put",
        }).then((response) => response.data);
    },
    permanentlyDeleteTable: (id) => {
        return request({
            url: `/tables/${id}/permanently-delete`,
            method: "delete",
        }).then((response) => response.data);
    },
    getTableById: (id) => {
        return request({
            url: `/tables/${id}`,
            method: "get",
        }).then((response) => response.data);
    },
    createTable: (name, description, template) => {
        return request
            .put(`/tables`, {
                name,
                description,
                template,
            })
            .then((response) => response.data);
    },
    updateTable: (tableId, data) => {
        return request.post(`/tables/${tableId}`, data).then((response) => response.data);
    },
    deleteTable: (tableId) => {
        return request({
            url: `/tables/${tableId}`,
            method: "delete",
        }).then((response) => response.data);
    },
    listFields: (tableId) => {
        return request({
            url: `/tables/${tableId}/fields`,
            method: "get",
        }).then((response) => response.data);
    },
    createField: (tableId, data) => {
        return request({
            url: `/tables/${tableId}/fields`,
            method: "put",
            data,
        }).then((response) => response.data);
    },
    updateField: (tableId, fieldId, data) => {
        return request.post(`/tables/${tableId}/fields/${fieldId}`, data).then((response) => response.data);
    },
    triggerAIField: (tableId, fieldId, filters, query) => {
        return request
            .post(`/tables/${tableId}/fields/${fieldId}/trigger`, { filters, query })
            .then((response) => response.data);
    },
    deleteField: (tableId, fieldId) => {
        return request({
            url: `/tables/${tableId}/fields/${fieldId}`,
            method: "delete",
        }).then((response) => response.data);
    },

    listRecords: (tableId, filters, sort, cursor, query) => {
        return request
            .post(`/tables/${tableId}/records`, {
                filters,
                sort,
                cursor,
                query,
                liteMode: true,
            }, {
                timeout: 1000 * 60,
            })
            .then((response) => response.data);
    },
    listRecordsV2: (tableId, filters, sort, cursor, query) => {
        return request
            .post(`/tables/${tableId}/records/v2`, {
                filters,
                sort,
                cursor,
                query,
                liteMode: true,
            }, {
                timeout: 1000 * 60,
            })
            .then((response) => response.data);
    },
    getRecordById: (tableId, recordId) => {
        return request({
            url: `/tables/${tableId}/records/${recordId}`,
            method: "get",
        }).then((response) => response.data);
    },
    createEmptyRecord: (tableId, filters, sort, cursor) => {
        return request(
            {
                url: `/tables/${tableId}/records/empty`,
                method: "put",
            },
            {}
        ).then((response) => response.data);
    },
    createRecordMulti: (tableId, values) => {
        return request.put(`/tables/${tableId}/records/multi`, { values }).then((response) => response.data);
    },
    updateRecord: (tableId, recordId, updatingFields) => {
        const updatingFieldsClone = _.cloneDeep(updatingFields);
        console.log("updateRecord", _.cloneDeep({ tableId, recordId, updatingFields }), updatingFieldsClone);
        return request
            .post(`/tables/${tableId}/records/${recordId}/update`, { updatingFields: updatingFieldsClone })
            .then((response) => response.data);
    },
    deleteRecordById: (tableId, recordId) => {
        return request.delete(`/tables/${tableId}/records/${recordId}`).then((response) => response.data);
    },
    deleteRecordsByIds: (tableId, recordIds) => {
        return request.post(`/tables/${tableId}/records/delete`, { recordIds }).then((response) => response.data);
    },

    // Duplicate records
    duplicateRecords: (tableId, recordIds) => {
        return request.post(`/tables/${tableId}/records/duplicate`, { recordIds }).then((response) => response.data);
    },

    // Update multiple records
    updateMultiRecord: (tableId, fieldId, recordIds, value) => {
        return request
            .put(`/tables/${tableId}/fields/${fieldId}/records`, { recordIds, value })
            .then((response) => response.data);
    },

    //#region VIEWS
    createView: (
        tableId,
        name,
        description,
        filters,
        sort,
        cursor,
        search,
        hiddenFields,
        lockedFields,
        groupValue,
        colorConditions
    ) => {
        return request
            .put(`/tables/${tableId}/views`, {
                name,
                description,
                filters,
                sort,
                cursor,
                search,
                hiddenFields,
                lockedFields,
                groupValue,
                colorConditions,
            })
            .then((response) => response.data);
    },

    deleteView: (tableId, viewId) => {
        return request({
            url: `/tables/${tableId}/views/${viewId}`,
            method: "delete",
        }).then((response) => response.data);
    },

    updateView: (tableId, viewId, updatingFields) => {
        return request.post(`/tables/${tableId}/views/${viewId}`, updatingFields).then((response) => response.data);
    },

    updateTableFieldPositions: (tableId, positions) => {
        return request.post(`/tables/${tableId}/positions`, { positions }).then((response) => response.data);
    },

    listViews: (tableId) => {
        return request({
            url: `/tables/${tableId}/views`,
            method: "get",
        }).then((response) => response.data);
    },
    searchFieldValues: (tableId, fieldId, query) => {
        return request.get(`/tables/${tableId}/${fieldId}/search?query=${query}`).then((response) => response.data);
    },
    listModuleRelatedListRecords: (tableId, recordId, moduleName) => {
        return request
            .get(`/tables/module-related-list?tableId=${tableId}&recordId=${recordId}&moduleName=${moduleName}`)
            .then((response) => response.data);
    },
    //#endregion

    //#region TablePage
    listTablePages: (tableId) => {
        log("listTablePages", { tableId });
        return request({
            url: `/tables/${tableId}/pages`,
            method: "get",
        }).then((response) => response.data);
    },

    getTablePage: (tableId, pageId) => {
        return request({
            url: `/tables/${tableId}/pages/${pageId}`,
            method: "get",
        }).then((response) => response.data);
    },

    createTablePage: (tableId, name, description, templateType) => {
        return request
            .put(`/tables/${tableId}/pages`, {
                table: tableId,
                name,
                description,
                templateType,
            })
            .then((response) => response.data);
    },

    updateTablePage: (tableId, pageId, updateData) => {
        return request.post(`/tables/${tableId}/pages/${pageId}`, updateData);
    },

    deleteTablePage: (tableId, pageId) => {
        return request({
            url: `/tables/${tableId}/pages/${pageId}`,
            method: "delete",
        }).then((response) => response.data);
    },
    //#endregion

    //#region Widget
    listWidgets: (tableId, pageId) => {
        log("listWidgets", { tableId, pageId });
        return request({
            url: `/tables/${tableId}/pages/${pageId}/widgets`,
            method: "get",
        }).then((response) => response.data);
    },

    getWidget: (tableId, pageId, widgetId) => {
        log("getWidget", { tableId, pageId, widgetId });
        return request({
            url: `/tables/${tableId}/pages/${pageId}/widgets/${widgetId}`,
            method: "get",
        }).then((response) => response.data);
    },

    createWidget: (tableId, pageId, type, settings, title) => {
        log("createWidget", { tableId, pageId, type, settings, title });
        return request
            .put(`/tables/${tableId}/pages/${pageId}/widgets`, {
                pageId,
                type,
                settings,
                title,
            })
            .then((response) => response.data);
    },

    updateWidget: (tableId, pageId, widgetId, updatedFields) => {
        log("updateWidget", { tableId, pageId, widgetId, updatedFields });
        return request
            .post(`/tables/${tableId}/pages/${pageId}/widgets/${widgetId}`, updatedFields)
            .then((response) => response.data);
    },

    deleteWidget: (tableId, pageId, widgetId) => {
        log("deleteWidget", { tableId, pageId, widgetId });
        return request({
            url: `/tables/${tableId}/pages/${pageId}/widgets/${widgetId}`,
            method: "delete",
        }).then((response) => response.data);
    },

    getChartData: (tableId, widgetId, upstreamFilters, customWidgetSettings) => {
        log("getChartData", { tableId, widgetId, upstreamFilters, customWidgetSettings });
        return request
            .post(
                `/tables/${tableId}/widgets/${widgetId}/chart-data`,
                { upstreamFilters, customWidgetSettings },
                {
                    timeout: 1000 * 60,
                }
            )
            .then((response) => response.data);
    },

    getNumberData: (tableId, widgetId, upstreamFilters) => {
        log("getNumberData", { tableId, widgetId, upstreamFilters });
        return request
            .post(`/tables/${tableId}/widgets/${widgetId}/number-data`, { upstreamFilters }, {
                timeout: 1000 * 60,
            })
            .then((response) => response.data);
    },

    getGanttData: (tableId, widgetId, upstreamFilters) => {
        log("getGanttData", { tableId, widgetId, upstreamFilters });
        return request
            .post(`/tables/${tableId}/widgets/${widgetId}/gantt-data`, { upstreamFilters }, {
                timeout: 1000 * 60,
            })
            .then((response) => response.data);
    },

    getPivotData: (tableId, widgetId, upstreamFilters, customWidgetSettings) => {
        log("getPivotData", { tableId, widgetId, upstreamFilters, customWidgetSettings });
        return request
            .post(
                `/tables/${tableId}/widgets/${widgetId}/pivot-data`,
                { upstreamFilters, customWidgetSettings },
                {
                    timeout: 1000 * 60,
                }
            )
            .then((response) => response.data);
    },

    updateWidgetPositions: (tableId, pageId, positions) => {
        log("updateWidgetPositions", { tableId, pageId, positions });
        return request
            .post(`/tables/${tableId}/pages/${pageId}/widgets/positions`, { positions })
            .then((response) => response.data);
    },
    //#endregion

    getPage: (tableId, pageId) => {
        log("getPage", { tableId, pageId });
        return request.get(`/tables/${tableId}/pages/${pageId}`).then((response) => response.data);
    },

    updateWidgets(tableId, pageId, updates) {
        log("updateWidgets", { tableId, pageId, updates });
        return request
            .put(`/tables/${tableId}/pages/${pageId}/widgets/positions`, {
                updates,
            })
            .then((response) => response.data);
    },

    updatePageLayout(tableId, pageId, layout) {
        log("updatePageLayout", { tableId, pageId, layout });
        return request.put(`/tables/${tableId}/pages/${pageId}/layout`, { layout }).then((response) => response.data);
    },

    duplicateWidget: (tableId, pageId, widgetId) => {
        log("duplicateWidget", { tableId, pageId, widgetId });
        return request
            .post(`/tables/${tableId}/pages/${pageId}/widgets/${widgetId}/duplicate`)
            .then((response) => response.data);
    },

    duplicatePage: (tableId, pageId) => {
        log("duplicatePage", { tableId, pageId });
        return request.post(`/tables/${tableId}/pages/${pageId}/duplicate`).then((response) => response.data);
    },

    duplicateTable: (tableId) => {
        return request.post(`/tables/${tableId}/duplicate`).then((response) => response.data);
    },

    exportTableAsJSON: (tableId) => {
        return request.get(`/tables/${tableId}/export`).then((response) => response.data);
    },

    importTableFromJSON: (importData) => {
        return request.post(`/tables/import`, { importData }).then((response) => response.data);
    },
};
